import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { HushedFrame } from '../screens/auth/HushedFrame';
import { UnsubscribePage } from '../screens/account/UnsubscribePage';

const searchSchema = z.object({
  /** The person's unsubscribe token, from the email. */
  t: z.string().min(32).max(64).catch(''),
  /** Which mail: the tips, getting started, or one job's learning notes; absent means the first two. */
  c: z.enum(['tips', 'getting_started', 'learning_notes']).optional().catch(undefined),
  /** A learning note's company and job: only that note stops. */
  n: z.string().uuid().optional().catch(undefined),
  j: z.string().uuid().optional().catch(undefined),
});

/**
 * An email's Unsubscribe and Email preferences links (docs/engineering/lifecycle-emails.md). No
 * sign-in: the link's token is the credential, and it can only change that person's mail.
 */
export const Route = createFileRoute('/email/unsubscribe')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { t, c, n, j } = Route.useSearch();
  // A learning note's link without its job names nothing to stop: it reads as the page's other mail.
  const note = c === 'learning_notes' && n && j ? { n, j } : undefined;
  return (
    <HushedFrame>
      <UnsubscribePage
        token={t}
        category={c === 'learning_notes' && !note ? null : (c ?? null)}
        {...(note ? { note } : {})}
      />
    </HushedFrame>
  );
}
